/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';

export class basecodereference extends IceEntity {
  base_code_reference_key: string = "";
  code_list_qualifier_code: string = "";
  base_code_key: string = "";
  title: string = "";
  code: string = "";
  price: number = 0.0;
  tax_status: IceTypes.sales_tax_status = IceTypes.sales_tax_status.stsNonTaxable;
  
  gettablename(): string {
    return "BASE_CODE_REFERENCE";
  }
}
